import { styled } from 'styled-components';

export const TacklingTableContainer = styled.div`
  padding: 0;
  padding-top: 0;
`;

TacklingTableContainer.displayName = 'TacklingTableContainer';
